/*
 *  Author: DL
 *  Date: 2020-12-03 14:28:29
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 17:44:18
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

function pxtorem(rem) {
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    return ((htmlWidth / 75) * rem) / 10;
}

const mapId = '1328677688368480258';

export default {
    mapId,
    mapOptions: {
        defaultThemeName: '1337325810359562242',
        appName: '诏安法院',
        key: '4e18cb00308df441af9985a914aede5b',
        mapServerURL: `./data/fmap/${mapId}`,
        mapThemeURL: './data/theme',
        defaultMapScaleLevel: 21,
        compassOffset: [pxtorem(20), pxtorem(230)],
        compassSize: pxtorem(50),
        focusAlphaMode: false,
        viewModeAnimateMode: false,
        focusAnimateMode: false,
        moveToAnimateMode: false,
    },
    showCompass: true,
};
